"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AAuth_1 = __importDefault(require("../AAuth"));
var http_1 = require("../../http/http");
var service_1 = __importDefault(require("../../services/service"));
var KCAuth = /** @class */ (function (_super) {
    __extends(KCAuth, _super);
    function KCAuth() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tokens = {};
        _this.storageFieldName = ['LRTokenKey', 'mona-sdk_accessToken'];
        _this.storageFieldNameUser = 'mona-sdk_user';
        return _this;
    }
    KCAuth.prototype.getAuthInSSO = function () {
        return __awaiter(this, void 0, void 0, function () {
            var responseLRLogin, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, (0, http_1.create)(service_1.default.authUrl, {
                                headers: {
                                    client: service_1.default.client,
                                },
                                params: {
                                    shouldValidateAnonymous: this.shouldValidateAnonymous,
                                    apiKey: service_1.default.apiKey,
                                },
                                withCredentials: true,
                            }).get('/login').then(function (_a) {
                                var data = _a.data;
                                return data;
                            })];
                    case 1:
                        responseLRLogin = _b.sent();
                        this.anonymousToken = responseLRLogin.anonymous_token;
                        if (!(responseLRLogin.isauthenticated && responseLRLogin.token)) return [3 /*break*/, 3];
                        _a = {};
                        return [4 /*yield*/, this.getUserFromAccessToken(responseLRLogin.token)];
                    case 2: return [2 /*return*/, (_a.user = _b.sent(),
                            _a.accessToken = responseLRLogin.token,
                            _a)];
                    case 3: return [2 /*return*/, {
                            user: undefined,
                            accessToken: undefined,
                        }];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_1 = _b.sent();
                        return [2 /*return*/, {
                                user: undefined,
                                accessToken: undefined,
                            }];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    KCAuth.prototype.setAuthInSSO = function (accessToken) {
        return (0, http_1.create)(service_1.default.authUrl, {}).get('/setCustomToken', {
            headers: {
                client: service_1.default.client,
            },
            params: {
                shouldValidateAnonymous: this.shouldValidateAnonymous,
                token: accessToken,
                apikey: service_1.default.apiKey,
                isrememberme: true,
            },
            withCredentials: true,
        }).then(function (_a) {
            var data = _a.data;
            return data;
        });
    };
    Object.defineProperty(KCAuth.prototype, "accessToken", {
        get: function () {
            return this.authLocalStorageIo.readAccessToken();
        },
        set: function (newAccessToken) {
            this.tokens['access'] = newAccessToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KCAuth.prototype, "apiToken", {
        get: function () {
            return this.tokens['api'];
        },
        set: function (newApiToken) {
            this.tokens['api'] = newApiToken;
        },
        enumerable: false,
        configurable: true
    });
    KCAuth.prototype.onLogoutHook = function (logoutResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, http_1.create)(service_1.default.authUrl, {}).get('/logout', {
                                headers: {
                                    client: service_1.default.client,
                                },
                                params: {
                                    shouldValidateAnonymous: this.shouldValidateAnonymous,
                                    apikey: service_1.default.apiKey,
                                },
                                withCredentials: true,
                            })];
                    case 1:
                        _a.sent();
                        this.clearAuth();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, logoutResponse];
                }
            });
        });
    };
    KCAuth.prototype.onLoginHook = function (loginResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var user, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.setAuthInSSO(loginResponse.access_token)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getUserFromAccessToken(loginResponse.access_token)];
                    case 2:
                        user = _a.sent();
                        this.setAuth('SSO', {
                            user: user,
                            accessToken: loginResponse.access_token,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.error(e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, loginResponse];
                }
            });
        });
    };
    KCAuth.prototype.onUserUpdateHook = function (updatedUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.accessToken) {
                    this.user = updatedUser;
                    this.authLocalStorageIo.write({
                        accessToken: this.accessToken,
                        user: this.user,
                    });
                }
                return [2 /*return*/, updatedUser];
            });
        });
    };
    return KCAuth;
}(AAuth_1.default));
exports.default = KCAuth;
